import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { styled } from '@mui/material/styles';

const LegendList = styled('ul')(() => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexWrap: 'wrap',
  gap: '10px',
  justifyContent: 'center',
}));

const ChartColorDot = styled('span')(() => ({
  display: 'inline-block',
  width: 10,
  height: 10,
  borderRadius: '50%',
}));

export const CustomLegend = ({ payload }) => {
  if (!payload || !payload.length) return null;

  return (
    <LegendList>
      {payload.map((entry, index) => {
        const code = entry.value; // ISO Alpha-2 (e.g., 'UA')

        return (
          <li
            key={index}
            style={{ display: 'flex', alignItems: 'center', gap: 6 }}
          >
            <ChartColorDot style={{ backgroundColor: entry.color }} />
            {code === '' ? (
              <span style={{ fontSize: 14 }}>N/A</span>
            ) : (
              <ReactCountryFlag
                countryCode={code}
                svg
                style={{ width: '1.2em', height: '1.2em', borderRadius: 2 }}
              />
            )}
          </li>
        );
      })}
    </LegendList>
  );
};
